<div class="bg-transparent page-not-found">
  <h1>404 - Page Not Found</h1>
  <p>Sorry, the page you are looking for does not exist.</p>
  <p>You may want to go back to the homepage or check if you have entered the correct URL.</p>
  <button (click)="goToHome()" class="bg-cyan fc-white btn-home">Go to Homepage</button>
</div>
